module.exports = __webpack_public_path__ + "img/calendar.f95c67cb.svg";